import React from 'react';

export const SmileCircleAdd = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 25"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3.24438C6.89137 3.24438 2.75 7.38575 2.75 12.4944C2.75 17.603 6.89137 21.7444 12 21.7444C17.1086 21.7444 21.25 17.603 21.25 12.4944C21.25 12.0802 21.5858 11.7444 22 11.7444C22.4142 11.7444 22.75 12.0802 22.75 12.4944C22.75 18.4314 17.9371 23.2444 12 23.2444C6.06294 23.2444 1.25 18.4314 1.25 12.4944C1.25 6.55732 6.06294 1.74438 12 1.74438C12.4142 1.74438 12.75 2.08017 12.75 2.49438C12.75 2.9086 12.4142 3.24438 12 3.24438Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.39746 16.0478C8.6441 15.715 9.11382 15.6452 9.44659 15.8918C10.1746 16.4314 11.0546 16.7444 12 16.7444C12.9454 16.7444 13.8254 16.4314 14.5534 15.8918C14.8862 15.6452 15.3559 15.715 15.6025 16.0478C15.8492 16.3806 15.7794 16.8503 15.4466 17.0969C14.4746 17.8174 13.2846 18.2444 12 18.2444C10.7154 18.2444 9.52541 17.8174 8.55341 17.0969C8.22063 16.8503 8.15081 16.3806 8.39746 16.0478Z"
      fill="currentColor"
    />
    <path
      d="M16 10.9944C16 11.8224 15.552 12.4944 15 12.4944C14.448 12.4944 14 11.8224 14 10.9944C14 10.1664 14.448 9.49438 15 9.49438C15.552 9.49438 16 10.1664 16 10.9944Z"
      fill="currentColor"
    />
    <path
      d="M9 12.4944C9.55228 12.4944 10 11.8228 10 10.9944C10 10.166 9.55228 9.49438 9 9.49438C8.44772 9.49438 8 10.166 8 10.9944C8 11.8228 8.44772 12.4944 9 12.4944Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 1.74438C19.4142 1.74438 19.75 2.08017 19.75 2.49438V8.49438C19.75 8.9086 19.4142 9.24438 19 9.24438C18.5858 9.24438 18.25 8.9086 18.25 8.49438V2.49438C18.25 2.08017 18.5858 1.74438 19 1.74438Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.25 5.49438C15.25 5.08017 15.5858 4.74438 16 4.74438H22C22.4142 4.74438 22.75 5.08017 22.75 5.49438C22.75 5.9086 22.4142 6.24438 22 6.24438H16C15.5858 6.24438 15.25 5.9086 15.25 5.49438Z"
      fill="currentColor"
    />
  </svg>
);
